import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  InfoGetInfo,
  InfoSetInfo,
} from "../../Api/Services";
import { toast } from "react-toastify";

function Info() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const start = async () => {
    try {
      const InfoGetInfoData = await InfoGetInfo();
      if (InfoGetInfoData.status && InfoGetInfoData.status === 200 && InfoGetInfoData.data.data) {
        setForm(InfoGetInfoData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (validation) {
      setLoading(true);
      try {
        const InfoSetInfoData = await InfoSetInfo(form);
        if (InfoSetInfoData.status && InfoSetInfoData.status === 200) {
          toast.success("بروزرسانی با موفقیت انجام شد");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="phone"
                id="phone"
                text="Phone"
                className="m-2"
                value={form.phone || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="tell"
                id="tell"
                className="m-2"
                text="Tell"
                value={form.tell || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="email"
                id="email"
                className="m-2"
                text="Email"
                value={form.email || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="telegram"
                id="telegram"
                className="m-2"
                text="Telegram"
                value={form.telegram || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="whatsApp"
                id="whatsApp"
                className="m-2"
                text="WhatsApp"
                value={form.whatsApp || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="bale"
                id="bale"
                className="m-2"
                text="Bale"
                value={form.bale || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="eita"
                id="eita"
                className="m-2"
                text="Eita"
                value={form.eita || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="instagram"
                id="instagram"
                className="m-2"
                text="Instagram"
                value={form.instagram || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="address"
                id="address"
                className="m-2"
                text="Address"
                value={form.address || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="fax"
                id="fax"
                className="m-2"
                text="Fax"
                value={form.fax || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="time"
                id="time"
                className="m-2"
                text="Time"
                value={form.time || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="description"
                id="description"
                className="m-2"
                text="Description"
                value={form.description || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {"ثبت"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Info;
